import {
  OurTeamContent,
  OurTeamSection,
  OurTeamWrapper,
} from "./OurTeam.styles";
import LandingButton from "../../LandingButton/LandingButton";

interface IOurTeam {
  title: string;
  subTitle: string;
  joinUsInfo: {
    title: string;
    subTitle: string;
    href: string;
    mail: string;
  };
  opportunities: {
    title: string;
    href: string;
  };
}

const OurTeam = ({ title, subTitle, joinUsInfo, opportunities }: IOurTeam) => {
  const handleExploreOpportunity = () => {};
  return (
    <OurTeamSection>
      <OurTeamWrapper>
        <OurTeamContent>
          <h2>{title}</h2>
          <p>{subTitle}</p>
          <h3>{joinUsInfo?.title}</h3>
          <p>
            {joinUsInfo?.subTitle}
            <a href={joinUsInfo?.href}>{joinUsInfo?.mail}</a>
          </p>
          <a
            href={opportunities?.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LandingButton
              customTitle={opportunities?.title}
              customWidth="300px"
              margin="40px 0 0 0"
              handleClick={handleExploreOpportunity}
            />
          </a>
        </OurTeamContent>
      </OurTeamWrapper>
    </OurTeamSection>
  );
};

export default OurTeam;
